import { store as company } from '../modules/company'
import { store as products } from '../modules/products'
import { store as cart } from '../modules/cart'
import { store as shipping } from '../modules/shipping'
import { store as clients } from '../modules/clients'
import { store as wishlist } from '../modules/wishlist'
import { store as address } from '../modules/address'
import { store as account } from '../modules/account'
import { store as payment } from '../modules/payment'
import { store as newsletter } from '../modules/newsletter'
import { store as location } from '../modules/location'
import { store as rate } from '../modules/rate'
import { store as contact } from '../modules/contact'
import { store as tellMeWhenArrive } from '../modules/tellMeWhenArrive'
import { store as recaptcha } from '../modules/recaptcha'
import { store as broadcast } from '../modules/broadcast'
import { store as toast } from '../modules/toast'
import { store as employee } from '../modules/employee'
import { store as modalCarousel } from '../modules/modalCarousel'
import { store as calendar } from '../modules/calendar'
import { store as quizzes } from '../modules/quizzes'
import { store as categories } from '../modules/categories'
import { store as deliveryTimes } from '../modules/deliveryTimes'
import { store as purchases } from '../modules/purchases'
import { store as modules } from '../modules/modules'

export default {
    company,
    products,
    cart,
    shipping,
    clients,
    wishlist,
    address,
    account,
    payment,
    newsletter,
    location,
    rate,
    contact,
    tellMeWhenArrive,
    recaptcha,
    broadcast,
    toast,
    employee,
    modalCarousel,
    calendar,
    quizzes,
    categories,
    deliveryTimes,
    purchases,
    modules,
}
